import React, { useEffect, useState } from "react";
import {
    Autocomplete,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Checkbox,
    FormControl,
    TextField,
    Grid,
    Divider,
    Typography,
    Paper,
    ListItemText,
    MenuItem,
    ListItemIcon,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import CustomFabButton from "../../components/Button/CustomFabButton";
import { useTranslation } from "react-i18next";
import validator from "validator";
import { getMaintenanceType, getMailGroupPeriod } from "../../store/actions/MaintenanceTypeActions";
import { useSelector, useDispatch } from "react-redux";
import MaintenanceTypeData from "../Dropdowns/MaintenanceType/MaintenanceTypeData";
import AreaGroup from "../Dropdowns/AreaGroup/AreaGroup";
import { getBreakDownTableArea } from "../../store/actions/BreakDownListTableActions";
import makeStyles from "@mui/styles/makeStyles";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const useStyles = makeStyles((_theme) => ({
    root: {
        "&$checked": {
            color: "#178580",
        },
    },
    checked: {},
    listItemText: {
        fontSize: "0.7em",
    },
}));

const AddEmailPopup = (props) => {
    const classes = useStyles();
    const { t } = useTranslation("translation");
    const { MaintenanceType } = useSelector((MaintenanceTypes) => MaintenanceTypes);
    const { breakDownListTable } = useSelector((breakDownState) => breakDownState);

    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState();
    const [selectedMaintenanceTypeIds, setSelectedMaintenanceTypeIds] = useState([]);
    const [mailPeriodId, setMailPeriodId] = useState(null);
    const [selectedAreaGroupIds, setSelectedAreaGroupIds] = useState([]);

    const [state, setState] = useState([
        {
            id: Date.now(),
            mailGroupId: props.mailGroupId,
            name: "",
            mailAdress: "",
            status: 1,
            errorText: t("InvalidEmail"),
            maintenanceTypeIds: [],
            mailPeriodId: null,
            areaGroupIds: [],
        },
    ]);

    const [data, setData] = useState([
        {
            maintenanceTypeIds: [],
            mailPeriodId: null,
            areaGroupIds: [],
        },
    ]);
    const [isEnabled, setIsEnabled] = useState(true);
    const [maintenanceTypesData, setMaintenanceTypes] = useState([]);
    const [isSendBreakdown, setIsSendBreakdown] = useState(false);
    const [areaData, setAreaData] = useState([]);
    const [emailList, setEmailList] = useState([]);
    const [mailOptions, setMailOptions] = useState();

    const dispatch = useDispatch();

    const filterEmails = () => {
        let filteredItems = props.rows.filter((item) => item.id === props.mailGroupId);
        setMailOptions(filteredItems)
        let emailAdressList = filteredItems[0].emailAddresses;
        setEmailList(emailAdressList);
        console.log('emailAdressList', emailAdressList);
       //setState([...state, emailAdressList]);
    };

    useEffect(() => {
        dispatch(getMaintenanceType());
        getMailGroupPeriodHandler();
        dispatch(getBreakDownTableArea());
        filterEmails();
    }, []);

    useEffect(() => {
        if (MaintenanceType?.maintenanceTypes?.length > 0) {
            setMaintenanceTypes(MaintenanceType.maintenanceTypes);
            MaintenanceType.maintenanceTypes = {};
        }
        if (MaintenanceType?.mailGroupPeriod?.length > 0) {
            setMailPeriodList(MaintenanceType.mailGroupPeriod);
        }
    }, [MaintenanceType]);

    useEffect(() => {
        if (breakDownListTable.areaList) {
            if (breakDownListTable.areaList.resultObject) {
                setAreaData(breakDownListTable.areaList.resultObject);
            }
        }
    }, [breakDownListTable.areaList]);

    // Mail Group Period
    const [mailPeriodList, setMailPeriodList] = useState([{ code: 0, description: "" }]);
    const getMailGroupPeriodHandler = () => {
        dispatch(getMailGroupPeriod());
    };

    const handleChange = (evt) => {
        const name = evt.target.id;
        const value = evt.target.value;
        var index = evt.target.getAttribute("index");

        var newState = state.slice();
        newState[index][name] = value;

        if (name == "mailAdress") {
            if (validator.isEmail(value)) {
                newState[index].errorText = "";
            } else {
                newState[index].errorText = t("InvalidEmail");
            }
        }

        setState(newState);
        handleDisableAddButton(newState);
    };

    const addRow = () => {
        var newRow = {
            id: Date.now(),
            mailGroupId: props.mailGroupId,
            name: "",
            mailAdress: "",
            status: 1,
            errorText: t("InvalidEmail"),
        };
        setState([...state, newRow]);
        handleDisableAddButton([...state, newRow]);
    };

    const removeRow = (row) => {
        var newState = state.filter((item) => item.id != row.id);
        setState(newState);
        handleDisableAddButton(newState);
    };

    const handleDisableAddButton = (newState) => {
        var disable = false;
        newState.forEach((item) => {
            if (item.errorText != "") {
                disable = true;
            }
        });
        setIsEnabled(disable);
    };

    // Maintenance Type

    const HandleMaintenanceTypeChange = (maintenanceName) => {
        if (maintenanceName !== null) {
            let ids = [];
            maintenanceName.map((item) => ids.push(item.id));
            setSelectedMaintenanceTypeIds(ids);
            setData({ ...data, maintenanceTypeIds: ids });
        } else {
            setSelectedMaintenanceTypeName(null);
        }
    };

    const HandleAreaFilterChange = (areaName) => {
        let areaGroupIds = [];
        areaName.map((item) => areaGroupIds.push(item.id));
        setSelectedAreaGroupIds(areaGroupIds);
        setData({ ...data, areaGroupIds: areaGroupIds });
    };

    const newMailPeriod = (mailPeriod) => {
        if (mailPeriod != null) {
            const filteredMailPeriod = mailPeriodList.filter((item) => item.description.includes(mailPeriod));
            setMailPeriodId(filteredMailPeriod[0].code);
            setData({ ...data, mailPeriodId: filteredMailPeriod[0].code });
            return [filteredMailPeriod[0].code, filteredMailPeriod[0].description];
        } else {
            setMailPeriodId(null);
        }
    };

    return (
        <Container id="aep_Container">
            <Dialog id="aep_Dialog" open={props.open} onClose={props.onCancel} fullWidth maxWidth="l">
                <Typography margin="auto">
                    <h2>{props.mailGroupName}</h2>
                </Typography>
                <DialogContent id="aep_DialogContent" dividers={true}>
                    <Grid container alignItems="center" sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Grid id="aep_Grid_1" item xs={12} sm={5} sx={{ alignSelf: "flex-start", marginLeft: "auto", marginRight: "auto" }}>
                            <Paper id="aep_Paper_1" elevation={2} sx={{ padding: 2 }}>
                                <Grid sx={{ height: 400, overflowY: "auto" }}>
                                    <DialogTitle id="aep_DialogTitle" sx={{ padding: 0 }}>
                                        {t("AddEmail")}
                                    </DialogTitle>
                                    <Divider color="#FDA228" sx={{ marginBottom: 2 }} />
                                    {state.map((row, index) => (
                                        <Grid id={`aep_Grid_0_${index}`} container direction={"column"} spacing={3}>
                                            <Grid id={`aep_Grid_1_${index}`} item sx={{ margin: 0.6 }}>
                                                <TextField
                                                    id="name"
                                                    label={t("Name")}
                                                    variant="outlined"
                                                    value={row.name}
                                                    onChange={handleChange}
                                                    inputProps={{ index: index }}
                                                    style={{ width: 155 }}
                                                    size="small"
                                                />
                                                <TextField
                                                    id="mailAdress"
                                                    label={t("Email")}
                                                    variant="outlined"
                                                    value={row.mailAdress}
                                                    onChange={handleChange}
                                                    inputProps={{ index: index }}
                                                    style={{ width: 250, marginLeft: 15 }}
                                                    error={row.errorText.length === 0 ? false : true}
                                                    helperText={row.errorText}
                                                    size="small"
                                                />
                                                {state.length > 1 ? (
                                                    <CustomFabButton
                                                        id={`aep_CFBR_${index}`}
                                                        title={t("Delete")}
                                                        onClick={() => removeRow(row)}
                                                        icon={<Remove />}
                                                        aria-label="delete"
                                                        style={{ marginLeft: 16, backgroundColor: "#E53935" }}
                                                    />
                                                ) : null}
                                                {index == state.length - 1 ? (
                                                    <CustomFabButton
                                                        id={`aep_CFBA_${index}`}
                                                        title={t("Add")}
                                                        onClick={addRow}
                                                        icon={<Add />}
                                                        aria-label="add"
                                                        style={{ marginLeft: 16, backgroundColor: "#00897B", position: "sticky" }}
                                                    />
                                                ) : null}
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Grid sx={{ height: 150, overflowY: "auto" }}>
                                    <DialogTitle id="aep_DialogTitle" sx={{ padding: 0, position: "sticky" }}>
                                        {t("EmailList")}
                                    </DialogTitle>
                                    <Divider color="#FDA228" sx={{ marginBottom: 2 }} />
                                    {emailList.map((data, index) => (
                                        <MenuItem>
                                            <ListItemIcon>
                                                <FiberManualRecordIcon sx={{ width: 5, height: 5 }} />
                                            </ListItemIcon>
                                            <ListItemText classes={{ primary: classes.listItemText }} primary={data.email} fontSize={1} id={`aep_ListItemText_${index}`} />
                                        </MenuItem>
                                    ))}
                                </Grid>
                            </Paper>
                        </Grid>

                        <Grid id="aep_Grid_2" item xs={12} sm={6} sx={{ margin: "auto", marginTop: 0 }}>
                            <Paper id="aep_Paper_2" elevation={2} sx={{ padding: 2 }}>
                                <DialogTitle id="aep_DialogTitle" sx={{ padding: 0 }}>
                                    {t("AddRelation")}
                                </DialogTitle>
                                <Divider color="#FDA228" sx={{ marginBottom: 2 }} />
                                <Grid id="aep_Grid_3" container direction="column" justifyContent="center">
                                    <Grid id="aep_Grid_4" item>
                                        <Grid id="aep_Grid_5" container direction="row" justifyContent="space-between" alignItems="center">
                                            <Grid id="aep_Grid_6" item xs={3}>
                                                <Typography id="aep_Typography" variant="body1">
                                                    {t("MaintenanceType")}
                                                </Typography>
                                            </Grid>
                                            <Grid id="aep_Grid_7" item xs={9}>
                                                <FormControl id="addEmailPopup_FormControl_1" variant="outlined" fullWidth>
                                                    <MaintenanceTypeData
                                                        HandleMaintenanceType={HandleMaintenanceTypeChange}
                                                        maintenanceTypeData={maintenanceTypesData}
                                                        maintenanceType={selectedMaintenanceTypeIds}
                                                        selectedMaintenanceTypeName={selectedMaintenanceTypeName}
                                                        size="small"
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid id="aep_Grid_7" item>
                                        <Grid id="aep_Grid_8" container direction="row" justifyContent="space-between" alignItems="center">
                                            <Grid id="aep_Grid_9" item xs={3}>
                                                <Typography id="aep_Typography" variant="body1">
                                                    {t("MailPeriod")}
                                                </Typography>
                                            </Grid>
                                            <Grid id="aep_Grid_7" item xs={9}>
                                                <FormControl id="addEmailPopup_FormControl_1" variant="outlined" fullWidth>
                                                    <Autocomplete
                                                        id="mt_AutoComplete_1"
                                                        defaultValue={mailPeriodId ? mailPeriodList.filter((item) => item.code == mailPeriodId)[0].description : ""}
                                                        onChange={(event, newValue) => {
                                                            newMailPeriod(newValue);
                                                        }}
                                                        options={mailPeriodList.map((option) => option.description)}
                                                        renderInput={(params) => <TextField {...params} margin="normal" label={t("MailPeriod")} variant="outlined" id="mt_TextField_4" />}
                                                        size="small"
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper id="aep_Paper_3" elevation={2} sx={{ padding: 2, marginTop: 4 }}>
                                <Grid id="aep_Grid_9">
                                    <Grid item>
                                        <FormControlLabel
                                            id="bd_formControlLabel"
                                            control={
                                                <Checkbox
                                                    id="bd_isEnvNotCleanCheckbox"
                                                    classes={{
                                                        root: classes.root,
                                                        checked: classes.checked,
                                                    }}
                                                    checked={isSendBreakdown}
                                                    onChange={(event) => setIsSendBreakdown(event.target.checked)}
                                                />
                                            }
                                            label={
                                                <Typography id="bd_typ_2" fontSize={13} fontStyle="bold">
                                                    <strong>{t("SendDailyBreakdownsWithEmails")}</strong>
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                    <Grid sx={{ display: isSendBreakdown ? "block" : "none" }}>
                                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                            <Grid id="aep_Grid_9" item xs={3}>
                                                <Typography id="aep_Typography" variant="body1">
                                                    {t("SelectAnAreaGroup")}
                                                </Typography>
                                            </Grid>
                                            <Grid id="aep_Grid_10" item xs={9}>
                                                <FormControl id="DetailFilter_FormControl_8" variant="outlined" fullWidth>
                                                    <AreaGroup
                                                        HandleAreaFilterChange={HandleAreaFilterChange}
                                                        areaData={areaData}
                                                        selectedAreaFilter={selectedAreaGroupIds}
                                                        isMultipleAreaGroup={true}
                                                        size="small"
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions id="aep_DialogActions">
                    <Button id="aep_Button_Cancel" onClick={props.onCancel} style={{ color: "#777777" }}>
                        {t("Cancel")}
                    </Button>
                    <Button id="aep_Button_Add" onClick={() => props.onAdd(state, data, emailList)} color="primary" disabled={isEnabled}>
                        {t("Add")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default AddEmailPopup;
